// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class AIChatService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getPromptSuggestions() {
        const url = this.urlsService.AI_CHAT.PROMPT_SUGGESTIONS;
        return this.ajaxService.getDataObserveBody(url);
    }
    getConversation(conversationId) {
        const url = this.urlsService.getUrl(this.urlsService.AI_CHAT.CONVERSATION, { conversationId });
        return this.ajaxService.getDataObserveBody(url);
    }
    deleteConversation(conversationId) {
        const url = this.urlsService.getUrl(this.urlsService.AI_CHAT.CONVERSATION, { conversationId });
        return this.ajaxService.deleteDataObserveBody(url);
    }
    savePromptAndResponseToConversation(data) {
        const url = this.urlsService.AI_CHAT.CREATE_CONVERSATION;
        return this.ajaxService.postJsonDataObserveBody(url, data);
    }
    getConversationHistory() {
        const url = this.urlsService.AI_CHAT.CONVERSATION_HISTORY;
        return this.ajaxService.getDataObserveBody(url);
    }
    addResponseFeedback(responseId, feedback) {
        const url = this.urlsService.AI_CHAT.EDIT_CONVERSATION;
        return this.ajaxService.postJsonDataObserveBody(url, {
            feedback,
            responseId,
        });
    }
    toggleDisclosure(showDisclosure) {
        return this.ajaxService.postJsonDataObserveBody(this.urlsService.AI_CHAT.DISCLOSURE, { showDisclosure });
    }
}
AIChatService.ɵfac = function AIChatService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AIChatService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
AIChatService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AIChatService, factory: AIChatService.ɵfac, providedIn: 'root' });
